import { useQuery } from '@tanstack/react-query';

import cycleMilestoneService from './cycleMilestoneService';

import type { CycleMilestone } from '@/types/cycle-evaluation/CycleMilestone';

import { CycleMilestoneQueryKey } from '@/constants/QueryKeys';

export const useGetCycleMilestonesByCycle = (cycleEvaluationGroupId?: string) =>
    useQuery<CycleMilestone[]>({
        queryKey: [CycleMilestoneQueryKey.CYCLE_MILESTONE, cycleEvaluationGroupId],
        queryFn: () =>
            cycleMilestoneService.getCycleMilestonesByCycle(cycleEvaluationGroupId as string),
        enabled: !!cycleEvaluationGroupId,
    });
